import initials from "../assets/initials.png"

import { Dropdown } from "flowbite-react";


export default function Navbar() {
    return (
        <>
        
            <div className="fixed lg:hidden z-50 backdrop-blur-sm w-screen bg-black bg-opacity-45 flex flex-row justify-between items-center pr-4">
                <a href="/"><img src={initials} className="h-16"/></a>
                    <Dropdown label="Menu" dismissOnClick={false} className="py-4 px-8 bg-stone-900 bg-opacity-80 border-fuchsia-600 rounded-xl text-white">
                        <Dropdown.Item><a href="/services" className="hover:text-sky-400 text-2xl">Services</a></Dropdown.Item>
                        <Dropdown.Item><a href="/contact" className="hover:text-sky-400 text-2xl">Contact us</a></Dropdown.Item>
                    </Dropdown>
            </div>
            <div className="hidden lg:fixed lg:flex z-50 backdrop-blur-sm w-screen bg-black bg-opacity-45 flex-row justify-between">
                <a href="/">
                    <img src={initials} className="h-16"/>
                </a>
                <div className="h-16 flex flex-row justify-between items-center w-[300px] px-8">
                    <a href="/services" className="hover:text-sky-400">Services</a>
                    <a href="/contact" className="hover:text-sky-400">Contact us</a>
                </div>
                
            </div>
        </>
        
    );
}